import { ControlsAbsoluteRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import {
  bannerHeight,
  largeFilterBarHeight,
  headerContentHeight,
} from 'src/components/PageLayout/dimensionUtils'
import { useBannerContext } from 'src/context/Banner/BannerContext'

export const useControlsIndexGridHeaderTop = (): number => {
  let top = 0
  const { bannerCount } = useBannerContext()
  const isControlsPage = location.pathname.includes(
    ControlsAbsoluteRoutes.INDEX,
  )
  if (isControlsPage) {
    top =
      headerContentHeight + largeFilterBarHeight + bannerCount * bannerHeight
  }
  return top
}
